import { Box, Typography } from '@mui/material';

import { EpisodeCountIcon } from '@/icons';

interface EpisodeCountProps {
  episodeCount: number;
}

export const EpisodeCount = ({ episodeCount }: EpisodeCountProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.25,
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      <EpisodeCountIcon sx={{ color: 'text.light', width: 12, height: 12 }} />
      <Typography variant="caption1Bold" color="text.light">
        {episodeCount} Episodes
      </Typography>
    </Box>
  );
};
